import React from "react";
import { motion } from "framer-motion"; // Add this import

const Disclaimer: React.FC = () => {
  return (
    <section style={{ padding: "40px 0" }}>
      {" "}
      {/* Added padding to separate sections */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div
          className="disclaimer"
          style={{
            backgroundColor: "#1e1e1e",
            padding: "50px 20px",
            color: "#fff",
            textAlign: "center",
            maxWidth: "800px", // Limit width for better readability
            margin: "0 auto", // Center the disclaimer
            borderRadius: "20px", // Rounded corners for aesthetics
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.5)", // Subtle shadow for depth
            boxSizing: "border-box", // Ensure padding is included in width calculations
          }}
        >
          <h1
            style={{
              fontFamily: "'Psychedelic Font', cursive",
              color: "#ff007f",
            }}
          >
            Disclaimer
          </h1>
          <p style={{ lineHeight: "1.6" }}>
            $METH coin has no association with any illegal substances or drugs.
            This token is simply paying homage to a meme and should not be taken
            as an endorsement or promotion of any drug-related activity.
          </p>
          <p style={{ lineHeight: "1.6" }}>
            $METH is a meme coin with no intrinsic value or expectation of
            financial return. It is completely useless and for entertainment
            purposes only.
          </p>
        </div>
      </motion.div>
    </section>
  );
};

export default Disclaimer;
